if (typeof window.QuickBuy === "undefined") {
  class QuickBuy {
    products = new Map();

    constructor() {}

    init() {
      this.products = new Map();

      $(".icon-quick-bulk").on("click", function () {
        $(this).parent().addClass("open");
      });

      $(".close-quick-buy").on("click", function () {
        $(this).parents('.media').removeClass("open");
      });
    }

    clickOption(el, inputId) {
      const dOption = el.dataset.option;
      const dValue = el.dataset.value;
      const dPosition = el.dataset.position;
      const dHandler = el.dataset.handler;
      const dType = el.dataset.type;
      const dContent = el.dataset.content;

      console.log("Quick Buy", {
        dOption,
        dValue,
        dPosition,
        dHandler,
        dType,
        dContent,
      });

      const labels = document.querySelectorAll(
        `label[data-option="${dOption}"]`
      );
      labels.forEach((label) => {
        label.classList.remove("input-active");
      });
      el.classList.add("input-active");
      const input = document.getElementById(inputId);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // if (dType) {
      const wrapper = el.closest(".single-product__option-wrapper");
      if (wrapper) {
        const selectedVariant = wrapper.querySelector(
          `.selected-variant[data-product="${dHandler}"]`
        );
        if (selectedVariant && dContent) {
          selectedVariant.textContent = `${dContent}`;
        }
      }
      // }

      // update Select value
      const selectEl = wrapper.parentElement.querySelector("select");
      if (!selectEl) {
        return;
      }

      this.products.set(dHandler, {
        ...this.products.get(dHandler),
        [dPosition]: dValue,
      });

      const selectItems = selectEl.querySelectorAll(
        `option[data-option-${dPosition}="${dValue}"]`
      );
      let selectValue = null;

      // product has only one option
      if (selectItems.length <= 1) {
        selectValue = selectItems?.[0]?.value || null;
      }
      // product has more one option
      if (selectItems.length > 1) {
        let selector = "option";
        Object.keys(this.products.get(dHandler)).forEach((key) => {
          const v = this.products.get(dHandler)[key];
          selector += `[data-option-${key}="${v}"]`;
        });
        const selectItem = selectEl.querySelector(selector);
        selectValue = selectItem?.value || null;
      }
      if (selectValue) {
        selectEl.querySelectorAll(`option`).forEach((option) => {
          option.removeAttribute("selected");
          if (option.value === selectValue) {
            option.setAttribute("selected", true);
          }
        });
      }
    }
  }
  window.QuickBuy = QuickBuy;
}

if (typeof window.quickBuy === "undefined") {
  window.quickBuy = new QuickBuy();
  window.quickBuy.init();
}
